import type { ReactNode } from "react";
import clsx from "clsx";

const InfoItem = ({
  children,
  icon,
}: {
  children: ReactNode;
  icon: ReactNode;
}) => {
  return (
    <div className="flex gap-2">
      {/* Icon */}
      <div className="flex items-start py-[0.24em] text-xs leading-tight">
        {icon}
      </div>
      <div className="text-sm leading-tight">{children}</div>
    </div>
  );
};

export default InfoItem;
